import { Reducer } from 'redux'
import { TeamMember, TEAM_ACTIONS, ActionTypes } from './types'

const initialState = {
  team: [],
}

type State = {
  team: TeamMember[]
}

export const team: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_ACTIONS.SET_TEAM:
      return {
        ...state,
        team: action.team,
      }
    default:
      return state
  }
}
